// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1eeZY","modalFooterButton":"ModalNotes_modalFooterButton__FL826"};